import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b23fa5a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=3b23fa5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports